import { useContext, useEffect, useState } from "react";
import { haveValue, toast } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import LandLordContext from "../../context/landlord/LandLordContext";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import constants from "../../Utils/constants";
import { Button, Card, InfoList, Notice, SkeletonText } from "../design";

const ReviewAssignProperty = (props) => {
  const { _t } = useTranslator();
  const { property, sharedProfile, formData, handlePrevStep } = props;
  const landLordContext = useContext(LandLordContext);
  const { initiateAssignProperty } = landLordContext;
  const authContext = useContext(AuthContext);
  const { loading, setLoading } = authContext;
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const [ieScore, setIeScore] = useState(0);
  const [ie_verified, setie_verified] = useState(false);

  const checkIeDetails = (userDetails) => {
    var check = false;

    setie_verified(check);
  };

  useEffect(() => {
    calculateIeScore();
  }, [ie_verified, sharedProfile]);
  useEffect(() => {
    checkIeDetails(sharedProfile?.tenantid);
  }, [sharedProfile]);

  const calculateIeScore = () => {
    var totalScore =
      (sharedProfile?.tenantid?.paymentScores?.creditScore?.value || 0) / 2;

    if (totalScore > 850) {
      totalScore = 850;
    }
    setIeScore(totalScore);
  };

  const handleInitiate = async () => {
    setLoading(true);
    const sendData = { ...formData };
    sendData.tenant_id = sharedProfile?.tenantid?._id;
    sendData.landlord_id = property?.landlord?._id;
    sendData.monthly_sub_amount = parseFloat(
      (
        (Math.abs(formData?.deposit_amount - formData?.rent_amount) *
          constants.SUBSCRIPTION_PERCENTAGE) /
        12
      ).toFixed(2)
    );

    initiateAssignProperty(sendData)
      .then((res) => {
        if (haveValue(res.status) && res.status == "success") {
          toast.success(_t("notificationSentToTenant"));
          navigate(
            `/${workspaceId}/payment/property/list?confirmation=true&assigned_prop=${res.notification.assigned_property_id}`
          );
        } else {
          toast.error(_t("errorWhileAssigningProperty"));
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(_t("errorWhileAssigningProperty123123"));
        console.log(err);
      });
  };
  return (
    <>
      <header className="assign-page__head">
        <h1>{_t("review")}</h1>
        <p>{_t("reviewAssignPropertySubtitle")}</p>
      </header>
      <Card>
        {/* grey lines until the property has loaded */}
        {property ? (
          <InfoList
            items={[
              {
                label: _t("moveInAddress"),
                value: `${property?.street} - ${
                  Number.isNaN(parseInt(property?.street_number, 10))
                    ? "N/A"
                    : String(parseInt(property?.street_number, 10))
                }, ${property?.floor_number}-${property?.flat_number}`,
              },
              {
                label: _t("landlord"),
                value: `${
                  haveValue(property?.landlord?.fname_companyName)
                    ? property?.landlord?.fname_companyName
                    : ""
                } ${
                  haveValue(property?.landlord?.lname)
                    ? property?.landlord?.lname
                    : ""
                }`,
              },
              {
                label: _t("tenant"),
                value: `${
                  haveValue(sharedProfile?.tenantid?.fname)
                    ? sharedProfile?.tenantid?.fname
                    : ""
                } ${
                  haveValue(sharedProfile?.tenantid?.lname)
                    ? sharedProfile?.tenantid?.lname
                    : ""
                }`,
              },
              {
                label: "Skor",
                value: haveValue(
                  sharedProfile?.tenantid?.gurantor_id?.paymentScores
                    ?.creditScore?.value
                )
                  ? sharedProfile?.tenantid?.gurantor_id?.paymentScores
                      ?.creditScore?.value
                  : sharedProfile?.tenantid?.paymentScores?.creditScore?.value,
              },
              { label: _t("leaseStartDate"), value: formData?.payment_start },
              {
                label: _t("leaseEndDate"),
                value: haveValue(formData?.lease_end)
                  ? formData?.lease_end
                  : _t("open"),
              },
              {
                label: _t("isItASharedHouseHold"),
                value: (
                  <span className="text-capitalize">
                    {formData?.shared_household}
                  </span>
                ),
              },
              {
                label: _t("rentalPaymentAmount"),
                value: formData?.rent_amount,
              },
              { label: _t("depositAmount"), value: formData?.deposit_amount },
            ]}
          />
        ) : (
          <SkeletonText
            lines={9}
            lineHeight={16}
            gap={20}
            label={_t("loading")}
          />
        )}
        <Notice className="assign-notice">
          {_t("tenantWillAddPaymentDetails")}.
        </Notice>
        <div className="assign-actions">
          <Button variant="secondary" size="lg" onClick={handlePrevStep}>
            {_t("editRentalDetails")}
          </Button>
          <Button size="lg" loading={loading} onClick={handleInitiate}>
            {_t("sendToTenant")}
          </Button>
        </div>
      </Card>
    </>
  );
};

export default ReviewAssignProperty;
